
class NavbarTopController {
    constructor() {
        this.searchCaption = this.searchCaption || 'Pretraži';
        this.onFilter = this.onFilter || angular.noop;
        this.hideFilter = this.onFilter === angular.noop;
        this.searchValue = '';
    }

    submit() {
        this.onFilter({value: this.searchValue});
    }
}

export {NavbarTopController};



// WEBPACK FOOTER //
// ./app/components/common/navbarTop/navbarTop.controller.js